(function () {
  const MONTERING_VARIANT_ID = 52758652780880;

  function $(sel) { return document.querySelector(sel); }

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function addMontering() {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: MONTERING_VARIANT_ID,
        quantity: 1,
        properties: { "_tjänst": "montering" }
      })
    });

    if (!res.ok) {
      const errText = await res.text();
      console.error('[Montering PDP] /cart/add.js failed:', errText);
      throw new Error(errText);
    }

    return res.json();
  }

  async function removeMonteringIfExists() {
    const cart = await getCart();
    const line = cart.items.find(i => i.variant_id === MONTERING_VARIANT_ID);
    if (!line) return;

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    });

    if (!res.ok) {
      const errText = await res.text();
      console.error('[Montering PDP] /cart/change.js failed:', errText);
      throw new Error(errText);
    }

    return res.json();
  }

  function setNote(text) {
    const el = $('#montering_note_pdp');
    if (el) el.textContent = text || '';
  }

  function getAddonPriceText(toggleEl) {
    // Reads from: <input ... data-price="+395 kr">
    const p = toggleEl?.dataset?.price;
    return (p && p.trim()) ? p.trim() : '+395 kr'; // fallback
  }

  async function init() {
    const toggle = $('#montering_toggle_pdp');
    if (!toggle) return;

    // IMPORTANT: never auto-tick on page load
    toggle.checked = false;

    // Optional: show a neutral hint by default (not "added", just info)
    const priceText = getAddonPriceText(toggle);
    setNote(`Endast tillgängligt vid hämtning i butik.`);

    toggle.addEventListener('change', async () => {
      toggle.disabled = true;

      try {
        if (toggle.checked) {
          await addMontering();
          setNote(`Montering kommer att läggas till i varukorgen (${priceText}).`);
        } else {
          await removeMonteringIfExists();
          setNote('Montering tas bort från varukorgen.');
        }
      } catch (e) {
        console.error('[Montering PDP] Toggle failed:', e);
        toggle.checked = !toggle.checked; // rollback
        setNote('Kunde inte uppdatera montering. Försök igen.');
      } finally {
        toggle.disabled = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();